import React,{useContext,useState} from 'react'
import noteContext from '../context/notes/noteContext';

export default function AddNote(props) {
  const context=useContext(noteContext);
  const {addNote}=context;
  const [note, setNote] = useState({title:"",description:"",tag:""})
  const AddNotes=(e)=>{
    //this will prevent the page refeshing on submit
    e.preventDefault();
    //send the note to the NoteState;
    addNote(note.title,note.description,note.tag);
    setNote({title:"",description:"",tag:""});
    props.showAlert("Note successfully added","success");
  }
  const onChange=(e)=>{
    // Whenever the target tag is change it will update its state too.
    setNote({...note,[e.target.name]: e.target.value})
  }
  return (
    <div>
      <div className="container my-3">
        <h1>Add a Note</h1>
        <form className='my-3'>
          <div className="mb-3">
            <label htmlFor="title" className="form-label">Title</label>
            <input type="text" className="form-control" name="title" id="title" aria-describedby="emailHelp" value={note.title} onChange={onChange}/>
          </div>
          <div className="mb-3">
            <label htmlFor="description" className="form-label">Description</label>
            <input type="text" className="form-control" name="description" id="description" value={note.description} onChange={onChange} />
          </div>
          <div className="mb-3">
            <label htmlFor="tag" className="form-label">Tag</label>
            <input type="text" className="form-control" name="tag" id="tag" value={note.tag} onChange={onChange} />
          </div>
          <button disabled={note.title.length<5 || note.description.length<5} type="submit" className="btn btn-primary" onClick={AddNotes}>Add Note</button>
        </form>
      </div>
    </div>
  )
}
